module.exports = __webpack_public_path__ + "assets/apache-traffic-server.437c2fb7.svg";